import React from "react";
import { ContextMenu, ContextMenuItem } from "src/components/ContextMenu";
import { useTasksContextMenu } from "./useTasksContextMenu";
import { PropsType } from "./types";
import { useAppContext } from "src/context/AppContext";

export const TasksContextMenu: React.FC<PropsType> = (props) => {
  const {
    handleOnClickClose,
    handleOnClickView,
    handleOnClickDelete,
    showDeleteDraftEntrance,
    showCTEntrance,
  } = useTasksContextMenu(props);
  const {
    context: { featureFlags },
  } = useAppContext();
  return (
    <ContextMenu consumerAnchorEl={props.consumerAnchorEl}>
      <ContextMenuItem onHandleClick={handleOnClickView}>View</ContextMenuItem>

      {showDeleteDraftEntrance && (
        <ContextMenuItem onHandleClick={handleOnClickDelete}>
          Delete...
        </ContextMenuItem>
      )}
      {showCTEntrance && featureFlags.showCloseButtonInContextMenu && (
        <ContextMenuItem onHandleClick={handleOnClickClose}>
          Close...
        </ContextMenuItem>
      )}
    </ContextMenu>
  );
};
